export default __webpack_public_path__ + "static/media/econt.9d611fee.png";